import ambient1 from './bensound-newdawn.mp3'
import ambient2 from './bensound-evolution.mp3'
import ambient3 from './bensound-betterdays.mp3'
import ambient4 from './bensound-tomorrow.mp3'

// {
//   data: something,
//   volume: 0.5
// }

export default {
  ambient1: {
    data: ambient1
  },
  ambient2: {
    data: ambient2
  },
  ambient3: {
    data: ambient3
  },
  ambient4: {
    data: ambient4
  }
}
